var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmailSuccessIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 272,
  height: 68,
  fill: "none",
  viewBox: "0 0 272 68"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#176F69",
  fillRule: "evenodd",
  d: "M268.487 8.642c1.016-.215 1.756.944 1.134 1.775L248.116 39.15a1.125 1.125 0 0 1-1.696.121l-4.857-4.857-5.352 4.738a.625.625 0 0 1-1.038-.43l-.682-11.38-8.031-8.03a1.125 1.125 0 0 1 .563-1.896zm-31.795 28.415 3.985-3.528-2.941-2.942zm.179-8.218a.63.63 0 0 0-.177.353l-.612 3.8-.333-5.557 19.259-9.95L237 28.74a.7.7 0 0 0-.129.099m-1.65-2.535 30.632-15.827-38.346 8.114zm11.981 11.981-8.891-8.89 29.208-18.256z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#009289",
  strokeDasharray: "12 12",
  strokeLinecap: "round",
  d: "M1 61.336c15.75-10.782 55.462-29.38 88.316-17.52 41.068 14.825 74.629 27.852 98.032 21.563C206.072 60.347 219.584 50.704 224 46.51"
})));
export { SvgEmailSuccessIcon as ReactComponent };